import styled from 'styled-components';

export const StyledUserDataDeletion = styled.div`
  .user-data-deletion-page {
    padding: 40px 20px;
    max-width: 800px;
    margin: 0 auto;
    min-height: 100vh;

    &__card {
      background: #fff;
      padding: 40px;
      border-radius: 16px;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
      line-height: 1.7;
      font-size: 16px;
      color: #444;
    }

    &__title {
      font-size: 28px;
      color: #1a1a2e;
      margin-bottom: 8px;
      font-weight: 700;

      @media (max-width: 600px) {
        font-size: 24px;
      }
    }

    &__update {
      color: #666;
      font-size: 14px;
      margin-bottom: 0;
      padding-bottom: 16px;
      border-bottom: none;
    }

    &__nav-links {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      padding: 12px 0 20px;
      margin-bottom: 8px;
      border-bottom: 1px solid #e0e0e0;
    }

    &__section-title {
      font-size: 20px;
      color: #1a1a2e;
      margin-top: 32px;
      margin-bottom: 12px;
      padding-left: 12px;
      border-left: 4px solid #ff6b35;
      font-weight: 600;
    }

    h3 {
      font-size: 17px;
      color: #1a1a2e;
      margin-top: 20px;
      margin-bottom: 8px;
      font-weight: 600;
    }

    p {
      margin-bottom: 12px;
    }

    ul,
    ol {
      background: #f8f9fa;
      padding: 16px 16px 16px 36px;
      border-radius: 10px;
      margin: 12px 0;

      li {
        margin-bottom: 8px;
        line-height: 1.6;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    ol {
      li {
        margin-bottom: 12px;
      }
    }

    strong {
      color: #1a1a2e;
    }

    &__footer {
      margin-top: 40px;
      padding-top: 24px;
      border-top: 1px solid #e0e0e0;

      p {
        color: #666;
        font-size: 14px;
        margin-bottom: 16px;
      }

      &__links {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        margin-top: 8px;
      }
    }

    a {
      color: #ff6b35;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
